import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import { logger, configSumoMeta } from '@origin-digital/reporting-client';
import { isNative } from '@origin-digital/platform-helpers';
import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _inheritsLoose from '@babel/runtime-corejs3/helpers/esm/inheritsLoose';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import { createContext, createElement, Component } from 'react';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import _Object$values from '@babel/runtime-corejs3/core-js-stable/object/values';

// Supports both >5.0.0 and <5.0.0 of react-native-webview
// If window.ReactNativeWebView exists, use new version of postMessage
var postMessage = function (message) {
  if (!isNative()) {
    logger.debug("[@od/natives-features]: postMessage is not supported outside of not in native", message);
  }

  var messageString = _JSON$stringify(message);

  window.ReactNativeWebView && window.ReactNativeWebView.postMessage ? window.ReactNativeWebView.postMessage(messageString) : window.postMessage ? window.postMessage(messageString, window.location.origin) : logger.error("postMessage() unavailable", {
    message: message
  });
};

//NOTE: keep this file in sync with feature.type.ts file in odin-mobile-appName
//https://bitbucket.org/origin-digital/odin-mobile-app/src/main/src/helpers/features.type.ts
var FEATURES;

(function (FEATURES) {
  FEATURES["requestAppInfo"] = "requestAppInfo";
  FEATURES["spinner"] = "spinner";
  FEATURES["viewpdf"] = "viewpdf";
  FEATURES["navClose"] = "navClose";
  FEATURES["navFocus"] = "navFocus";
  FEATURES["navModal"] = "navModal";
  FEATURES["navStandard"] = "navStandard";
  FEATURES["navTab"] = "navTab";
  FEATURES["navExternal"] = "navExternal";
  FEATURES["navExternalAuth"] = "navExternalAuth";
  FEATURES["httpReqError"] = "httpReqError";
  FEATURES["reauthenticate"] = "reauthenticate";
  FEATURES["openResource"] = "openResource";
  FEATURES["navBack"] = "navBack";
})(FEATURES || (FEATURES = {}));

var NavFlow;

(function (NavFlow) {
  NavFlow["FOCUS"] = "focus";
  NavFlow["MODAL"] = "modal";
  NavFlow["STANDARD"] = "standard";
  NavFlow["EXTERNAL"] = "external";
  NavFlow["EXTERNAL_AUTH"] = "externalAuth";
  NavFlow["TAB"] = "tab";
})(NavFlow || (NavFlow = {}));

var Tab;

(function (Tab) {
  Tab["DASHBOARD"] = "dashboard";
  Tab["USAGE"] = "usage";
  Tab["BILLS"] = "bills";
  Tab["HELP"] = "help";
  Tab["MORE"] = "more";
})(Tab || (Tab = {}));

var receiveMessage = function (event) {
  if (event.data) {
    var _context;

    var message = event.data;

    if (typeof event.data === "string") {
      message = JSON.parse(event.data);
    } else {
      message = event.data;
    }

    var features = _reduceInstanceProperty(_context = message.features || []).call(_context, function (obj, key) {
      obj[key] = true;
      return obj;
    }, {});

    var appInfo = message.appInfo;
    return {
      features: features,
      appInfo: appInfo
    };
  }

  return undefined;
};
var fetchNativeFeatures = function () {
  return new _Promise(function (resolve, reject) {
    try {
      if (!isNative()) {
        reject(new Error("[@od/natives-features]: fetchNativeFeatures is not supported outside of native"));
      } //process message event


      var messageEventHandler = function (event) {
        var nativeFeatures = receiveMessage(event);

        if (nativeFeatures) {
          //remove message event listener
          document.removeEventListener("message", messageEventHandler);
          resolve(nativeFeatures);
        } else {
          reject(new Error("[@od/natives-features]: did not receive any message from native"));
        }
      }; //add message event listener


      document.addEventListener("message", messageEventHandler); //request app info

      postMessage({
        action: FEATURES.requestAppInfo
      });
    } catch (error) {
      logger.error("[@od/natives-features] fetchNativeFeatures:", error);
      reject(new Error("[@od/natives-features]: fetchNativeFeatures: " + error));
    }
  });
};

var _context, _context2;

var notInitialisedFn = function () {
  throw new Error("NativeFeaturesProvider not initialised");
};

var featuresOff = _reduceInstanceProperty(_context = _Object$keys(FEATURES)).call(_context, function (obj, key) {
  obj[key] = false;
  return obj;
}, {});

var NativeFeaturesContext = createContext({
  isNative: false,
  actions: _reduceInstanceProperty(_context2 = _Object$keys(FEATURES)).call(_context2, function (obj, key) {
    obj[key] = notInitialisedFn;
    return obj;
  }, {}),
  features: featuresOff
});
var NativeFeaturesProvider = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NativeFeaturesProvider, _React$Component);

  function NativeFeaturesProvider(props) {
    var _this = _React$Component.call(this, props) || this;

    _this.sendMessage = function (message) {
      if (!_this.state.features[message.action]) {
        logger.warn("[@od/natives-features]: the native wrapper does not support this feature", message);
      }

      postMessage(message);
    };

    _this.actions = {
      navFocus: function navFocus(data) {
        return _this.sendMessage({
          action: FEATURES.navFocus,
          data: data
        });
      },
      navStandard: function navStandard(data) {
        return _this.sendMessage({
          action: FEATURES.navStandard,
          data: data
        });
      },
      navTab: function navTab(data) {
        return _this.sendMessage({
          action: FEATURES.navTab,
          data: data
        });
      },
      navExternal: function navExternal(data) {
        return _this.sendMessage({
          action: FEATURES.navExternal,
          data: data
        });
      },
      spinner: function spinner(data) {
        return _this.sendMessage({
          action: FEATURES.spinner,
          data: data
        });
      },
      viewpdf: function viewpdf(data) {
        return _this.sendMessage({
          action: FEATURES.viewpdf,
          data: data
        });
      }
    };
    _this.state = {
      isNative: isNative(),
      features: _extends({}, featuresOff, {
        requestAppInfo: true
      })
    };
    return _this;
  }

  var _proto = NativeFeaturesProvider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (isNative()) {
      fetchNativeFeatures().then(function (nativeFeatures) {
        _this2.setState(function (prevState) {
          return _extends({}, prevState, {
            features: _extends({}, prevState.features, {}, nativeFeatures.features)
          });
        }); //configure sumo meta


        if (!_this2.props.noConfigSumoMeta && configSumoMeta) {
          configSumoMeta({
            nativeApp: nativeFeatures
          });
        }
      });
    }
  };

  _proto.render = function render() {
    var value = _extends({}, this.state, {
      actions: this.actions
    });

    return createElement(NativeFeaturesContext.Provider, {
      value: value
    }, this.props.children);
  };

  return NativeFeaturesProvider;
}(Component);
var NativeFeaturesConsumer = NativeFeaturesContext.Consumer;

var features = {
  features: _Object$values(FEATURES),
  appInfo: {
    version: "1.alpha.test",
    platform: "nativeEmulator",
    userAgent: "nativeEmulator; odin"
  }
};

var dispatchFeatureEvent = function () {
  document.dispatchEvent(new MessageEvent("message", {
    data: features
  }));
}; // https://stackoverflow.com/questions/5999118/how-can-i-add-or-update-a-query-string-parameter


function updateQueryString(key, value, url) {
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi");
  var hash;

  if (re.test(url)) {
    if (typeof value !== "undefined" && value !== null) {
      return url.replace(re, "$1" + key + "=" + value + "$2$3");
    } else {
      hash = url.split("#");
      url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");

      if (typeof hash[1] !== "undefined" && hash[1] !== null) {
        url += "#" + hash[1];
      }

      return url;
    }
  } else if (typeof value !== "undefined" && value !== null) {
    var separator = _indexOfInstanceProperty(url).call(url, "?") === -1 ? "?" : "&";
    hash = url.split("#");
    url = hash[0] + separator + key + "=" + value;

    if (typeof hash[1] !== "undefined" && hash[1] !== null) {
      url += "#" + hash[1];
    }

    return url;
  } else {
    return url;
  }
}

function addNativeTrue(url) {
  return updateQueryString("native", "true", url);
}

var handler = {
  requestAppInfo: function requestAppInfo() {
    return dispatchFeatureEvent();
  },
  navBack: function navBack() {
    return history.back();
  },
  navExternal: function navExternal(data) {
    window.open(data.url);
  },
  navExternalAuth: function navExternalAuth(data) {
    window.open(data.url);
  },
  navFocus: function navFocus(data) {
    if (data.show) {
      window.open(addNativeTrue(data.url));
    } else {
      window.close();
    }
  },
  navModal: function navModal(data) {
    if (data.show) {
      window.open(addNativeTrue(data.url));
    } else {
      window.close();
    }
  },
  navTab: function navTab(data) {
    logger.error("[nativeEmulator]: navTab not supported", data);
  },
  navStandard: function navStandard(data) {
    window.location.assign(data.url);
  },
  navClose: function navClose() {
    window.close();
  },
  openResource: function openResource(data) {
    window.open(addNativeTrue(data.url));
  },
  spinner: function spinner(data) {
    return logger.error("[nativeEmulator]: spinner not supported", data);
  },
  viewpdf: function viewpdf(data) {
    return window.open(data.url);
  },
  httpReqError: function httpReqError(data) {
    return logger.error("[nativeEmulator]: httpReqError not supported", data);
  },
  reauthenticate: function reauthenticate(data) {
    return logger.error("[nativeEmulator]: reauthenticate not supported", data);
  }
};
var nativeEmulator = function () {
  if (isNative()) {
    logger.info("[nativeEmulator]: enabled");
    window.addEventListener("message", function (event) {
      if (event.data && typeof event.data === "string") {
        var payload = JSON.parse(event.data) || {};
        var _ref = payload,
            action = _ref.action,
            _data = _ref.data;
        if (!action) return;

        if (handler[action]) {
          logger.debug("[nativeEmulator] postMessage to odin", payload);
          handler[action](_data);
        } else {
          logger.debug("[nativeEmulator] no native handler for action", payload);
          return;
        }
      }

      if (!(event.data && event.data.source === "react-devtools-bridge" || event.data && event.data.source === "react-devtools-content-script")) {
        logger.trace("[nativeEmulator]: message ignored", event);
      }
    }, false);
    dispatchFeatureEvent();
  } else {
    logger.info("[nativeEmulator]: not running isNative: false)");
  }
};

export { FEATURES, NativeFeaturesConsumer, NativeFeaturesProvider, NavFlow, Tab, fetchNativeFeatures, nativeEmulator, postMessage, receiveMessage };
